import React from 'react'
import NumberState from '../Sandbox/NumberState'
import TwentyOneGame from '../Sandbox/TwentyOneGame'

function BlackJack() {
    return (
        <TwentyOneGame />
    )
}
export default BlackJack